import { Box, Stack, Typography } from '@mui/material';

import brandMark from 'assets/images/zhilv-mark.svg';

const BrandLockup = ({ compact = false, showTagline = true }) => (
  <Stack direction="row" alignItems="center" spacing={compact ? 0.75 : 1}>
    <Box
      component="img"
      src={brandMark}
      alt="智旅云品牌标志"
      sx={{
        width: compact ? 38 : 43,
        height: compact ? 34 : 38,
        flex: '0 0 auto',
        display: 'block'
      }}
    />
    <Box sx={{ minWidth: 0 }}>
      <Typography
        component="span"
        sx={{
          display: 'block',
          color: '#18221F',
          fontSize: compact ? 19 : 21,
          fontWeight: 850,
          lineHeight: 1.05,
          whiteSpace: 'nowrap'
        }}
      >
        智旅云
      </Typography>
      {showTagline && (
        <Typography
          component="span"
          sx={{
            display: 'block',
            color: '#66736E',
            fontSize: compact ? 11 : 12,
            lineHeight: 1.2,
            mt: 0.25,
            whiteSpace: 'nowrap'
          }}
        >
          酒店全员AI营销工具
        </Typography>
      )}
    </Box>
  </Stack>
);

export default BrandLockup;
